import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { UserService } from '../services/user.service';
import  * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import * as AppConstant from '../app.string';
import { PackageService } from '../services/package.service';

@Component({
  selector: 'app-health-package-preview',
  templateUrl: './health-package-preview.component.html',
  styleUrls: ['./health-package-preview.component.scss']
})
export class HealthPackagePreviewComponent {
  @Output() package = new EventEmitter();
  public packs: any = [];
  currency_code: any;
  public healthPackages: Array<any> = [];
  private healthPackageFetched: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public packageClassified: boolean = false;
  public readonly onDemandAttributes: any = {};
  constructor(private user:UserService, private cdf: ChangeDetectorRef, private packageService: PackageService){}

  ngOnInit(): void {
    this.currency_code = this.user.getCurrency();
    const data = this.user.getUpdateInfoSync('directives');
    if (data) {
      data.userDefined.find(def => { 
        if(def.directiveGroup == 'HOSPSERV'){
          this.user.setStorage(AppConstant.HEALTHPKG_LIST, JSON.stringify(def));
          
          this.packs.push(_.cloneDeep(def));
          // if(this.packs['concepts'].length >3)
          // this.packs['concepts'].length = 3;
        }
      })
      this.getAllHealthPackages(this.packs)
    }
  }


  private getAllHealthPackages(packs) {
    let healthPackages = packs || [];
    console.info('healthPackages', healthPackages);
    let allPackages = []
    let packages = allPackages?.length ? allPackages : healthPackages
    this.packageService.setAllPackages(packages);
    console.info('packages>>>>>', packages);
    let reducedHealthPackages = packages.reduce((r, a) => {
      let pack, concepts = [];
      if (a._directiveRef) {
        pack = _.cloneDeep(a._directiveRef);
        delete a._directiveRef
        concepts = [a];
      } else {
        pack = a;
        concepts = a.concepts;
      }
      let packHead = {
        code: pack.code,
        directiveGroup: pack.directiveGroup,
        facilities: pack.facilities,
        sysDef: pack.sysDef,
        name: pack.name,
        imageUrl: pack.imageUrl,
        expanded: pack.expanded,
        canRequest: pack.canRequest,
        isPackageApplicable:pack.isPackageApplicable
      }
      concepts.forEach(concept => {
        if(concept && concept['name'] && concept['name'].length > 0){
          let _name = concept['name'].find(t => {
            return t.locale == this.user.getCurrentLanguage()
          })
          concept['pkgName'] = _name ? _name['name'] : ""
        }else {
          concept['pkgName'] = concept['name'] ? concept['name'] : ""
        }
        if (concept.packageDtls && (concept.packageDtls.isPackageApplicable && concept.packageDtls.isPackageApplicable == 'Y')) {
          r.push({
            package: _.cloneDeep(packHead),
            concept: _.cloneDeep(concept)
          })
        }
      })
      return r;
    }, [])
    //hardcoded HLTHPKGS directive only to show in home page as display priority changes not included in 8.1.9.0
    reducedHealthPackages = reducedHealthPackages.filter(p => (p.package && p.package.isPackageApplicable && p.package.isPackageApplicable == 'Y')).sort((a, b) => {a['_displayPriority']-b['_displayPriority']})
    reducedHealthPackages = _.orderBy(reducedHealthPackages, ["concept['_displayPriority']", "concept['pkgName']"], ["asc", "asc"])
    console.info('reducedHealthPackages', reducedHealthPackages)
    this.healthPackages = reducedHealthPackages;
    this.healthPackageFetched.next(true);
    this.getPackageClassification()
  }

  private getPackageClassification() {
    if (this.packageClassified) return;
    const wellnessPackages = this.healthPackages.filter(pack => pack?.concept?.packageDtls?.packageClassification !== 'PROMO');
    const promoPackages = this.healthPackages.filter(pack => pack?.concept?.packageDtls?.packageClassification === 'PROMO');
    const wellNessPackageClassification = this.user.getPackageClassification().map(c => {
      const specialityCount = wellnessPackages?.filter(pack => pack?.concept?.packageDtls?.packageSpeciality === c.code)?.length || 0;
      return {
        image: c.ppWellnessCardImage,
        label: `WELLNESS#SEPCIALITY#${c.code}`,
        bgColor: c.ppWellnessCardIBgColor,
        count: specialityCount,
        options: {
          classification: 'WELLNESS',
          speciality: c.code
        }
      }
    }).filter(c=> c.count > 0)
    const promoPackageClassification = this.user.getPackageClassification().map(c => {
      const specialityCount = promoPackages?.filter(pack => pack?.concept?.packageDtls?.packageSpeciality === c.code)?.length || 0;
      return {
        image: c.ppPromoPackageImage,
        bgColor: c.ppPromoPackageCardBgColor,
        label: `PROMO#SEPCIALITY#${c.code}`,
        count: specialityCount,
        options: {
          classification: 'PROMO',
          speciality: c.code
        }
      }
    }).filter(c => c.count > 0);
    this.onDemandAttributes.wellNessPackageClassification = wellNessPackageClassification;
    this.onDemandAttributes.promoPackageClassification = promoPackageClassification;
    this.cdf.detectChanges()
    this.packageClassified = true
  }

  pkgSeeAll(click, option) {
    this.package.emit({click: click, options: option})
  }

  openPackages(type, element?) {
    this.package.emit({click: type, options: element?.options});
  }

  public getChargeByFacility(pack){
    let charge: any;
    if(pack.facilities.length){
      charge = pack.facilities[0].controls.charge
    }
    return charge;
  }
  public getDiscountChargeByFacility(pack){
    let discountCharge:any;

    if(pack.facilities.length){
      discountCharge = pack.facilities[0].controls.discountCharge
    }
    return discountCharge;
  }
}
